export default __webpack_public_path__ + "static/media/Untitled_design_95_1024x1024.865c1d7f.jpg";